import { elixirsEndpoints } from "./elixirs.api"

export const {
  useGetAllElixirsQuery,
  useGetUsersElixirsQuery,
  useBuyElixirMutation,
  useActivateElixirMutation,
  useActivatePremiumElixirMutation,
  useGetActivatedPremiumElixirsQuery,
  useGetActivatedElixirsQuery,
  useGetCountQuery,
  endpoints: {
    getAllElixirs,
    getUsersElixirs,
    buyElixir,
    activateElixir,
    activatePremiumElixir,
    getActivatedPremiumElixirs,
    getCount
  }
} = elixirsEndpoints
